import React, { Component } from "react";
import { path } from "ramda";
import { Row, Col, Card , Tooltip, Modal } from "antd";
import styled, { withTheme, css } from "styled-components";
import i18n from "../../i18n";
import { ThemeHelper } from "../../hoc/with/withThemeProvider";
import Metrics from "../../theme/Metrics";
import Color, { DataVisualizeKeys } from "../../theme/Colors";
import { isFunction } from "../../util";
import { SimpleText, SingleLine, OThemeText } from "../text/OText";
import { isFillAlive, ArrayUtil, ColorUtil } from "../../util/";
import EmptyModal from "../modal/EmptyModal";
import Colors from "../../theme/Colors";

const EmptyBar = styled.div`
    min-height:50px;
`;

const HorizontalBar = styled.div`
  border-radius: ${Metrics.progressBar.horizontalBar.borderRadius}px;
  height: 28px;
  background: ${props => props.color};
  width: ${props => props.width * 100}%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color : #ffffff;
`;

const TextInBar = styled.span`
  width: 48.4px;
  height: 21px;
  font-weight: ${Metrics.progressBar.textInProgressBar.fontWeight};
  line-height: ${Metrics.progressBar.textInProgressBar.lineHeight}px;
  color: ${Metrics.progressBar.textInProgressBar.color};
  margin-left: ${Metrics.progressBar.textInProgressBar.marginLeft}px;
`;
const TopicName = styled.span`
  font-size: ${Metrics.progressBar.TopicName.fontSize}px;
  text-align: ${Metrics.progressBar.TopicName.textAlign};
  color: ${Metrics.progressBar.TopicName.color};
`;

const Title = styled.p`
  font-size: ${Metrics.fontSize.header}px;
  font-weight: bold;
`;
export const EmptyDataBar = (props)=>(
	<EmptyHorizontalBar>
		<TextInEmptyHorizontalBar>{i18n.t("no_data")}</TextInEmptyHorizontalBar>
	</EmptyHorizontalBar>
);
const EmptyHorizontalBar = styled.div`
  height: 21px;
`;
const TextInEmptyHorizontalBar = styled.span`
  color: ${Color.unimportantFontAlphaColor};
`;

const Box = props => {
	const { title, id, value } = props;
	const widthBar = (props.value / props.allValueTopic);
	return <div style={{ marginBottom: 0 }}>
		<TopicName>{props.title}</TopicName>
		<Tooltip title={`${props.title} : ${props.value} (${(widthBar * 100).toFixed(2)}%)`}>
			{props.value != 0 ? <HorizontalBar onClick={props.onClick ? () => props.onClick(
				{
					title,
					id,
					value
				}
			) : undefined} color={props.color} width={widthBar.toFixed(2)}>
				<TextInBar>{(widthBar * 100).toFixed(2)}%</TextInBar>
			</HorizontalBar> : <EmptyDataBar />}
		</Tooltip>
	</div>;
};
const LoadMoreBtn = styled.div`
  text-align:center;
  color:${props=>props.color};
  cursor:pointer;
`;

class HorizontalBarGraph extends Component {
  moreModal = null;
  render() {
  	const { sort = true ,isLoadMore= true, showSize = 3, style = undefined, 
  		header, showHeader, colorType = DataVisualizeKeys.Primary, 
  		theme, data = { Work: {id:1,count:10} }, onClick
  	} = this.props;
  	const isDead = !isFillAlive(data);
  	const arrayTopic = isDead ? [] : Object.keys(data).map(Val => { 
  		if(typeof data[Val] === "object"){
  			return { 
  				label : Val,
  				id: data[Val].id, 
  				value:data[Val].count 
  			};
  		}
  		return { 
  			label : Val,
  			value:data[Val]
  		};
  	});
  	const objSorted = sort? arrayTopic.sort((a,b)=> b.value - a.value): arrayTopic;
  	const objSortedSlice = isLoadMore ? objSorted.slice(0, showSize) : objSorted;
  	const keyTopic = isDead ? [] : Object.keys(data);
  	const allValueTopic = ArrayUtil.isAliveArray(keyTopic) ?
  		objSorted.reduce((a,b) => a+b.value,0) : [];
  	const color = ColorUtil.getVisualizeColor(theme,colorType,0);
  	return <div style={{height:"100%",
  		...style,
  		overflow:"auto", 
  		justifyContent:isLoadMore ? "space-between" : "normal",
  		display:"flex",
  		flexDirection:"column",
  	}}>
  		<div>
  			{showHeader ? <Title>{header}</Title> : undefined}
  			{isDead ? <p style={{color:Colors.unimportantFontAlphaColor}}>
  				{i18n.t("no_data")}
  			</p> : <div>
  				{ArrayUtil.isAliveArray(keyTopic) ? objSortedSlice.map(
  					(Val, index) => (
  						<Box
  							key={index}
  							title={Val.label}
  							id={Val.id}
  							value={Val.value}
  							allValueTopic={allValueTopic}
  							color={color}
  							elementStyle={style}
  							onClick={onClick}
  						/>
  					)
  				) 
  					: <EmptyBar />}
  			</div>
  			}
  		</div>
  		{!isDead && isLoadMore ? <div>
  			<LoadMoreBtn 
  				color={color}
  				onClick={()=>{
  					this.moreModal.showModal();
  				}}>
  				{i18n.t("load_more")}
  			</LoadMoreBtn>
  			<EmptyModal ref={(ref)=>{
  				this.moreModal = ref;
  			}} width={450} >
  				<HorizontalBarGraph {...this.props} 
  					style={{minHeight:300}}
  					showHeader={true} 
  					isLoadMore={false}
  				/>
  			</EmptyModal>
  		</div> : undefined}
  	</div>;
  }
}
export default withTheme(HorizontalBarGraph);


// WEBPACK FOOTER //
// ./src/components/chart/ProgressReturningBar.js